<script lang="ts">
	//UI
	import { HubProfileTextInput, DefaultButton } from "@hitit/new_ui";
	import ProfileInputFrame from "./ProfileInputFrame.svelte";
	import ProfileViewer from "./ProfileViewer.svelte";
	import CancelButton from "./CancelButton.svelte";
	//Utils
	import { t, api } from "../../../stores";
	import type { ProfileData, UserData } from "@hitit/api";

	//Props
	export let user: UserData;
	export let userId: string | undefined = undefined;
	export let profile: ProfileData;

	//variables
	let name = "";
	let editMode = false;
	let loading = false;
	//functions
	async function updateUsername() {
		try {
			loading = true;
			const newUser = Object.assign({}, user, { name: name });
			await $api.updateUser(newUser, userId);
			user = newUser;
			editMode = false;
			name = user.name;
		} catch (e) {
			console.log(e);
		} finally {
			loading = false;
		}
	}

	$: disabled = name === "";
	$: backgroundColor = disabled ? "#a5c1f9" : "#6b93f3";

</script>

<div class="container" class:editMode>
	{#if editMode}
		<div class="frame-wrapper">
			<div class="frame">
				<ProfileInputFrame name={$t('hub.profile.current_user_name')}>
					<div class="contents-container">
						<span class="value">{user.name}</span>
					</div>
				</ProfileInputFrame>
			</div>
			<div class="frame">
				<ProfileInputFrame name={$t('hub.profile.new_user_name')}>
					<HubProfileTextInput bind:value={name} />
				</ProfileInputFrame>
			</div>
		</div>
		<div class="button-box">
			<DefaultButton
				-name-save={true}
				nonePadding
				disabled={disabled}
				background={backgroundColor}
				fitmode
				isLoading={loading}
				on:click={() => updateUsername()}>
				<span>{$t('global.save')}</span>
			</DefaultButton>
		</div>
		<div class="cancel">
			<CancelButton on:click={() => (editMode = false)} />
		</div>
	{:else}
		<div class="frame">
			<ProfileViewer
				name={$t('hub.profile.name')}
				value={user.name}
				editIcon={!(profile.cellphone?.includes("Azure"))}
				on:click={() => (editMode = true)} />
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	div {
		box-sizing: border-box;
	}

	.container {
		display: flex;
		position: relative;
		flex-direction: column;
		gap: 10px;
		flex-grow: 1;
		padding: 0 20px;

		&.editMode {
			background-color: #e6e7ed;
			padding: 20px;
		}

		:global(.-name-save) {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.frame-wrapper {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
	.frame {
		flex-grow: 1;
	}
	.button-box {
		height: 32px;
		span {
			font-weight: 500;
			font-size: 1rem;
			color: white;
			margin-top: -1px;
		}
	}

	.contents-container {
		display: flex;
		flex-grow: 1;
		justify-content: space-between;
		align-items: center;
	}

	.value {
		color: #46474b;
		font-weight: 500;
	}
	.cancel {
		position: absolute;
		top: 10px;
		right: 10px;
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			padding: 0px 40px;
			gap: 20px;

			&.editMode {
				padding: 20px 40px;
			}

			.frame-wrapper {
				flex-grow: 1;
			}

			.button-box {
				width: 150px;
				height: 40px;
				margin-top: auto;
				span {
					font-size: 1.25rem;
				}
			}
		}

		.value {
			font-size: 1.25rem;
		}
		.cancel {
			position: absolute;
			top: 20px;
			right: 20px;
		}
	}

</style>
